export function w3_open() {
    document.getElementById("mySidebar").style.display = "block";
  }